import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import { Logo, SectionLabel } from "@/components/bits";
import { DISCORD_URL } from "@/lib/images";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen flex items-center justify-center px-5" data-testid="payment-cancel-page">
      <div className="w-full max-w-lg text-center">
        <Logo size={48} withText={false} />
        <XCircle size={44} className="mx-auto text-white/60 mt-8" />
        <SectionLabel className="justify-center mt-8">CHECKOUT CANCELLED</SectionLabel>
        <h1 className="mt-4 font-display text-4xl sm:text-5xl uppercase">No Charge Made</h1>
        <p className="mt-4 text-white/55">Your payment was cancelled and you have not been charged. Your cart is still waiting whenever you're ready.</p>
        <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
          <Link to="/store" data-testid="cancel-store-btn" className="btn-inj px-8 py-4 text-sm">RETURN TO STORE</Link>
          <a href={DISCORD_URL} target="_blank" rel="noreferrer" className="btn-ghost px-8 py-4 text-sm">GET SUPPORT</a>
        </div>
      </div>
    </div>
  );
}
